import { colors } from "../../Styles";

export function Empty({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <g transform="matrix(0.867865,0,0,0.867865,18.5075,18.6225)">
          <path d="M141.73,9.29C68.71,9.29 9.29,68.71 9.29,141.73C9.29,214.75 68.7,274.17 141.73,274.17C214.76,274.17 274.17,214.76 274.17,141.73C274.17,68.7 214.76,9.29 141.73,9.29ZM141.73,252.789C83.03,252.789 31.823,200.43 31.823,141.73C31.823,83.03 83.03,30.671 141.73,30.671C200.43,30.671 252.789,83.163 252.789,141.863C252.789,200.563 200.43,252.789 141.73,252.789Z"/>
      </g>
      <g transform="matrix(0.795495,-0.795495,0.855932,0.855932,-5.94275,49.6369)">
          <path d="M43,30.435C43,26.332 39.415,23 35,23C30.585,23 27,26.332 27,30.435L27,249.565C27,253.668 30.585,257 35,257C39.415,257 43,253.668 43,249.565L43,30.435Z"/>
      </g>
    </svg>
  );
}